import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, Link } from 'react-router-dom'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Button } from 'components/Button'
import { ProjectCard } from 'components/ProjectCard'
import { useFetchRecentProjects } from 'services/project'
import { GeoSearch } from 'features/shared/GeoSearch'
import { Text } from 'components/Text'
import { LocationSearch } from 'models/geosearch'
import styles from './Dashboard.module.scss'

export const Dashboard: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { projects = [] } = useFetchRecentProjects()
  const [search, setSearch] = useState<LocationSearch | null>(null)

  //const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
  //event.preventDefault()
  //commit
  //}

  const navegaExplora = () => {
    navigate('/explore', { state: { search } })
  }

  return (
    <div className={styles.dashboard}>
      <div className={styles.formContainer}>
        <Stack space="large">
          <Stack space="small">
            <Heading align="center">{t('dashboard.title')}</Heading>
          </Stack>

          <Stack space="medium">
            <GeoSearch
              name="address"
              placeholder={t('dashboard.form.location')}
              onSelect={setSearch}
            />
            <Button full type="submit" onClick={navegaExplora}>
              {t('dashboard.form.cta')}
            </Button>
          </Stack>
        </Stack>
      </div>
      {projects.length > 0 && (
        <div className={styles.recentProjectsContainer}>
          <Stack>
            <Heading align="center">{t('dashboard.recentProjects')}</Heading>
            <div className={styles.recentProjects}>
              {projects.map((project) => (
                <ProjectCard project={project} key={project.id} />
              ))}
            </div>

            <Text className={styles.projectsLink} align="center" weight="strong">
              <Link to="/projects">{t('dashboard.link')}</Link>
            </Text>
          </Stack>
        </div>
      )}
    </div>
  )
}

Dashboard.displayName = 'Dashboard'
